module.exports = __webpack_public_path__ + "img/wawa3_slide_2.d5b774b4.jpg";